// Stato di consenso cookie condiviso tra il banner e il plugin di analytics
// (vue-gtag.client.js). SSR è disabilitato in questo progetto (SPA), quindi
// localStorage è sempre disponibile lato client.
const STORAGE_KEY = 'cookie_consent_gioelemonni'

const consentGiven = ref(
  typeof localStorage !== 'undefined' ? localStorage.getItem(STORAGE_KEY) === 'accepted' : false
)
const consentDecided = ref(
  typeof localStorage !== 'undefined' ? localStorage.getItem(STORAGE_KEY) !== null : false
)

export function useCookieConsent() {
  const setConsent = (accepted) => {
    consentGiven.value = accepted
    consentDecided.value = true
    if (typeof localStorage !== 'undefined') {
      localStorage.setItem(STORAGE_KEY, accepted ? 'accepted' : 'rejected')
    }
  }

  return { consentGiven, consentDecided, setConsent }
}
